import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { auth } from "../../lib/auth";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await auth.login(email, password);
      navigate("/admin", { replace: true });
    } catch (ex) {
      const detail = ex.response?.data?.detail;
      setErr(typeof detail === "string" ? detail : "No se pudo iniciar sesión");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen flex items-center justify-center bg-black px-6">
      <form onSubmit={submit} className="w-full max-w-md">
        <p className="font-mono text-[10px] tracking-[0.4em] text-[var(--magenta)]">ADMIN · CONTROL ROOM</p>
        <h1 className="mt-3 font-display uppercase font-bold tracking-tighter text-5xl sm:text-6xl">
          Iniciar <span className="text-[var(--magenta)] normal-case">sesión</span>
        </h1>
        <p className="mt-3 text-white/50 text-sm">Acceso restringido al editor del archivo.</p>

        <div className="mt-10 space-y-6">
          <label className="block">
            <span className="block text-[10px] tracking-[0.4em] uppercase font-display text-white/40">Email</span>
            <input
              required type="email" autoComplete="username"
              data-testid="admin-email"
              value={email} onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-transparent border-b border-white/20 focus:border-[var(--magenta)] outline-none py-3 text-lg"
            />
          </label>
          <label className="block">
            <span className="block text-[10px] tracking-[0.4em] uppercase font-display text-white/40">Contraseña</span>
            <input
              required type="password" autoComplete="current-password"
              data-testid="admin-password"
              value={password} onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-transparent border-b border-white/20 focus:border-[var(--magenta)] outline-none py-3 text-lg"
            />
          </label>
        </div>

        {err && <p className="mt-4 text-[var(--magenta)] text-sm" data-testid="admin-error">{err}</p>}

        <button
          type="submit" disabled={loading}
          data-testid="admin-submit"
          className="mt-10 inline-flex items-center gap-3 border border-white/20 hover:border-[var(--magenta)] hover:text-[var(--magenta)] disabled:opacity-50 px-8 py-4 text-[12px] tracking-[0.3em] uppercase font-display"
        >
          {loading ? "Entrando…" : "Entrar"}
        </button>
      </form>
    </div>
  );
}
